<template>
  <button @click.prevent="toggleBookmark()">
    <i class="fa-bookmark" :class="{'fa-light': !isBookmarked, 'fa-solid': isBookmarked}"/>
  </button>
</template>

<script>
export default {
  name: "bookmark-button",
  props: {
    value: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      isBookmarked: false
    }
  },
  computed: {
    bookmarks: function () {
      switch (this.type) {
        case "article":
          return window.ArticleBookmarks;
        case "announcement":
        case "machine":
        case "product":
        case "shared":
        case "competence":
        case "job":
        case "course":
        case "post":
          return window.PostBookmarks;
        default:
          throw "Invalid type: " + this.type;
      }
    }
  },
  mounted: function () {
    this.loadBookmarks();
    window.addEventListener("pageshow", this.handlePageshow);
  },
  beforeDestroy: function () {
    window.removeEventListener("pageshow", this.handlePageshow);
  },
  methods: {
    handlePageshow() {
      this.loadBookmarks();
    },
    toggleBookmark() {
      if (!window.visitor || !window.visitor.person) {
        Vue.$hashUtil.add("paywall");
        return;
      }
      const newValue = !this.isBookmarked;
      this.bookmarks.set(this.$services.bookmarkSecureService, this.value, newValue).then(() => {
        this.isBookmarked = newValue;
      });
    },
    loadBookmarks() {
      if (window?.visitor?.person) {
        this.bookmarks.init(this.$services.bookmarkSecureService, [this.value], (data) => {
          this.isBookmarked = data[this.value];
        }, (newValue) => {
          this.isBookmarked = newValue;
        });
      }
    },
  }
}
</script>